import axios from "axios";

const Api = axios.create({
  baseURL: "https://social-media-project-1-qxnx.onrender.com/api/v1",
  withCredentials: true,
});


export default Api;